import config from 'baseConfig/pg/v2/suspicious';

export default {
  TABLE_COLUMNS: [
    {
      key: 'riskyAddedOn',
      displayName: 'Created At',
      width: 1.5,
      tooltip: {
        message: 'Suspicious Transaction Added On',
      },
    },
    ...config?.TABLE_COLUMNS,
  ],
  FILTER_ITEMS: { ...config.FILTER_ITEMS },
  SEARCH_ITEMS: [...config.SEARCH_ITEMS],
};
